export const MenuSurveyOptions = [
  {
    label: "😍 Great! Can't wait",
    value: 3,
  },
  {
    label: "🙂 Good. A couple of appealing choices",
    value: 2,
  },
  {
    label: "😕 Not good. Nothing very appealing",
    value: 1,
  },
  {
    label: "😭 Bad! I got the best of a bad bunch",
    value: 0,
  },
];

export const ERROR_MODAL_CONTENT = {
  title: "Error submitting survey",
  confirmationContent: "Sorry, we weren't able to submit your survey response",
  cancelButtonText: "",
  confirmButtonText: "Ok",
};
